
let scrollTimeout;
function resetMenuIfDesktop() {
  if (window.innerWidth >= 768) {
    const topMenu = document.querySelector(".header-wrapper");
    const openMenu = document.querySelector(".open");

    if (openMenu) {
      openMenu.classList.remove("openTop");
      openMenu.classList.remove("open"); 
    }
  }
}

window.addEventListener("resize", resetMenuIfDesktop);
resetMenuIfDesktop();

document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.getElementById("menu-toggle");
  const mobileMenu = document.querySelector(".header-content-mobile");
  if (toggleButton && mobileMenu) {
    toggleButton.addEventListener("click", function () {
      
      mobileMenu.classList.toggle("open");
    });
  }
});

document.querySelectorAll(".mobile-nav-menu a").forEach((link) => {
  link.addEventListener("click", () => {
    mobileMenu.classList.remove("open");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const toggles = document.querySelectorAll("li.menu-item-has-children > a");

  toggles.forEach((toggle) => {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const parentLi = toggle.closest("li.menu-item-has-children");

      const childOpenItems = parentLi.querySelectorAll(
        "li.menu-item-has-children.open"
      );
      childOpenItems.forEach((child) => {
        if (child !== parentLi) {
          child.classList.remove("open");
        }
      });

      parentLi.classList.toggle("open");
    });
  });
});
